export default {
  apiKey: "AIzaSyBZS4Py5rdx7sSEm5yfrgMh32XL2WAblFM",
  authDomain: "seez-test.firebaseapp.com",
  databaseURL: "https://seez-test.firebaseio.com",
  projectId: "seez-test",
  storageBucket: "seez-test.appspot.com",
  messagingSenderId: "1000932228643",
  appId: "1:1000932228643:web:e4da9fc10bccb72b",
};
